<template>
	<history-page :url="url"/>
</template>

<script>
export default {
	computed: {
		url () {
			return process.env.VUE_APP_API_ROOT + '/api/projects_other/' + this.$route.params.id + '/history'
		}
	}
}
</script>